document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector("form.ticket, form.internal_ticket")
    const assigneeTypeInputs = form?.querySelectorAll('input[name*="ticket[assignee_type]"]')
    const assigneeSelectWrapper = form?.querySelector('li[id*="ticket_assignee_id_input"]')
    const assigneeSelect = assigneeSelectWrapper?.querySelector('select[name*="ticket[assignee_id]"]')

    if (!assigneeTypeInputs || !assigneeSelect) return

    const selectPromptOption = assigneeSelect.querySelector('option[value=""]')

    const roleOptGroup = assigneeSelect.querySelector('optgroup[label="Department"], optgroup[label="قسم"]')
    const userOptGroup = assigneeSelect.querySelector('optgroup[label="User"], optgroup[label="مستخدم"]')

    const setGroupVisibility = (groupEl, show) => {
        if (!groupEl) return

        const opts = groupEl.querySelectorAll('option')

        groupEl.hidden = !show
        groupEl.disabled = !show

        opts.forEach(opt => {
            opt.hidden = !show
            opt.disabled = !show
        })
    }

    const resetToPrompt = () => {
        assigneeSelect.selectedIndex = -1
        if (selectPromptOption) selectPromptOption.selected = true
    }

    const updateAssigneeOptions = (selectedValue) => {
        resetToPrompt()

        if (selectedValue === "Role" || selectedValue === "User") {
            assigneeSelectWrapper.classList.remove('hidden')

            const isRole = selectedValue === 'Role'

            setGroupVisibility(roleOptGroup, isRole)
            setGroupVisibility(userOptGroup, !isRole)

        } else {
            assigneeSelectWrapper.classList.add('hidden')
        }
    }

    const addEventListeners = () => {
        assigneeTypeInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                updateAssigneeOptions(e.target.value)
            })
        })
    }

    const initialize = () => {
        resetToPrompt()
        assigneeSelectWrapper.classList.add("hidden")
        assigneeTypeInputs.forEach(input => input.checked = false)
    }

    initialize()
    addEventListeners()
})
